import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	listByDays: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/oa/teacherAttendance/listByDays", params, successCallback, failCallback, exceptionCallback);
	},
	// save: (params, successCallback, failCallback, exceptionCallback) => {
	// 	ApiUtils.postLoadingAjax(constant.serverUrl + "/office/teacherAttendance/save", params, successCallback, failCallback, exceptionCallback);
	// },
	// toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
	// 	ApiUtils.getLoadingAjax(constant.serverUrl + "/office/teacherAttendance/toUpdate", params, successCallback, failCallback, exceptionCallback);
	// },
	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/oa/teacherAttendance/updateremarks", params, successCallback, failCallback, exceptionCallback);
	},
	 remove: (params, successCallback, failCallback, exceptionCallback) => {
	 	ApiUtils.deleteLoadingAjax(constant.serverUrl + "/oa/teacherAttendance/remove", params, successCallback, failCallback, exceptionCallback);
	 },
	listTeachersWithMthes: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/oa/teacherAttendance/listTeachersWithMthes", params, successCallback, failCallback, exceptionCallback);
	},
	listByTid: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/oa/teacherAttendance/listByTid", params, successCallback, failCallback, exceptionCallback);
	},
	getDays: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/oa/teacherAttendance/listDaysInMth", params, successCallback, failCallback, exceptionCallback);
	},
	repair: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/oa/teacherAttendance/repair", params, successCallback, failCallback, exceptionCallback);
	},
}

export default api;
